import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { endpoints } from '../endpoints';
import { IDistricCoordinatorTraining } from '../models/schedule';
import { ErrorService } from '../helpers/errorService';

@Injectable({
    providedIn: 'root'
})
export class DistrictCoordinatorTrainingService {
    constructor(
        private http: HttpClient,
        private errorService: ErrorService
    ) { }

    getBuildingCoordinatorTrainings(buildingId: string, schoolYear: string): Observable<{ has_error: boolean, message: string, data: IDistricCoordinatorTraining[] }> {
        const url = environment.apiBaseUrl + endpoints.getBuildingCoordinatorTrainings.replace(':buildingId', buildingId);

        const params = new HttpParams().set('school_year', schoolYear);

        return this.http.get<{ has_error: boolean, message: string, data: IDistricCoordinatorTraining[] }>(url, { params }).pipe(
            catchError(this.errorService.handleError)
        );
    }


    createNewCoordinatorTraining(buildingId: string, data: FormData): Observable<{ has_error: boolean, message: string, data: any }> {
        const url = environment.apiBaseUrl + endpoints.createNewCoordinatorTraining.replace(':buildingId', buildingId);
        return this.http.post<{ has_error: boolean, message: string, data: any }>(url, data).pipe(
            catchError(this.errorService.handleError)
        );
    }

    updateCoordinatorTraining(itemId: string, data: FormData): Observable<any> {
        const url = environment.apiBaseUrl + endpoints.updateCoordinatorTraining.replace(':itemId', itemId);
        return this.http.put<any>(url, data).pipe(
            catchError(this.errorService.handleError)
        );
    }

    deleteCoordinatorTraining(itemId: string): Observable<any> {
        const url = environment.apiBaseUrl + endpoints.deleteCoordinatorTraining.replace(':itemId', itemId);
        return this.http.delete<any>(url).pipe(
            catchError(this.errorService.handleError)
        );
    }
}